if (!customElements.get('shoppable-layout-slider')) {
  class ShoppableLayoutSlider extends HTMLElement {
    constructor() {
      super();
      this.style.opacity = '0'; // hidden until initialized
      this.style.transition = 'opacity 0.3s ease-out';

      if (Shopify.designMode) {
        window.addEventListener(
          'shopify:section:load',
          this.observeSection.bind(this)
        );
      }
      this.observeSection();
    }

    observeSection() {
      const observer = new IntersectionObserver(
        entries => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              this.init();
              observer.disconnect(); // remove observer after initialized
            }
          });
        },
        { threshold: 0.1 }
      );
      observer.observe(this);
    }

    init() {
      if (this.swiper) return; // prevent reinitialization

      const swiperContainer = this.querySelector('.swiper-shoppable-slider');
      if (!swiperContainer) return;

      this.swiper = new Swiper(swiperContainer, {
        autoplay: false,
        spaceBetween: 20,
        slidesPerView: 'auto',
        navigation: {
          nextEl: '.swiper-button--next',
          prevEl: '.swiper-button--prev'
        },
        breakpoints: {
          1200: {
            spaceBetween: 40,
            slidesPerView: 3.8
          },
          990: {
            spaceBetween: 32,
            slidesPerView: 3.4
          },
          750: {
            spaceBetween: 24,
            slidesPerView: 2.4
          },
          360: {
            spaceBetween: 16,
            slidesPerView: 1.4
          }
        },
        on: {
          init: () => {
            this.style.opacity = '1'; // show after initialized
            this.playLoadedVideos();
          }
        }
      });
    }

    playLoadedVideos() {
      const videos = this.querySelectorAll('video');
      if (!videos.length) return;

      // Phones only fetch a video once play() is called, so play each one when it is on screen
      // (this also starts the download) and pause it when it scrolls or swipes away.
      const play = video => {
        video.muted = true; // necessary for autoplay
        video.playsInline = true;
        const promise = video.play();
        if (promise) promise.catch(() => {}); // autoplay blocked (e.g. Low Power Mode): poster stays
      };

      if (!('IntersectionObserver' in window)) {
        videos.forEach(play);
        return;
      }

      const observer = new IntersectionObserver(
        entries => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              play(entry.target);
            } else {
              entry.target.pause();
            }
          });
        },
        { threshold: 0.25 }
      );
      videos.forEach(video => observer.observe(video));
    }

    open(event, index, id) {
      document.querySelector(`shoppable-drawer.shoppable-drawer--${id}`).openWithIndex(event, index);
    }
  }

  customElements.define('shoppable-layout-slider', ShoppableLayoutSlider);
}